import * as React from "react";
import {Field} from "react-final-form";

class Payment extends React.Component {

	newCardForm = () => {
		const current_year = new Date().getFullYear();
		const years = Array(20).fill(0).map((e, i) => {
			const year = current_year + i;
			return (<option key={year} value={year}>{year}</option>)
		});

		const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'].map((month, i) => (
			<option key={month} value={i + 1}>{month}</option>
		))

		return (
			<div className="row">
				<div className="col-sm-6">
					<Field
						name="ccNumber"
						component="input"
						type="text"
						placeholder="Card Number"
						required
					/>
				</div>
				<div className="col-sm-2">
					<Field name="expmonth" component="select" required>
						<option value="" style={{display: 'none'}} default selected>Month</option>
						{months}
					</Field>
				</div>
				<div className="col-sm-2">
					<Field name="expyear" component="select" required>
						<option value="" style={{display: 'none'}} default selected>Year</option>
						{years}
					</Field>
				</div>
				<div className="col-sm-2">
					<Field
						name="cvv"
						component="input"
						type="text"
						placeholder="CVV"
						required
					/>
				</div>
			</div>
		);
	}

	billingProfiles = () => {
		const options = this.props.profiles.map((profile, i) => {
			return (<option key={profile.profile_id} selected={!i} value={profile.profile_id}>{profile.description}</option>)
		});

		const style = {
			backgroundColor: 'green'
		};

		return (
			<div className="row">
				<div className="col-sm-8">
					<Field name="billingProfile" component="select" required>
						<option value="" style={{display: 'none'}} default selected>Choose Card</option>
						{options}
					</Field>
				</div>
				<div className="col-sm-2">
					<Field
						name="cvv"
						component="input"
						type="text"
						placeholder="CVV"
						required
					/>
				</div>
				<div className="col-sm-2">
					<button type="submit" className="login-button" style={style} disabled={true}>New Card</button>
				</div>
			</div>
		);
	}

	render() {
		const paymentOptions = this.props.profiles && this.props.profiles.length ? this.billingProfiles() : this.newCardForm();

		return (
			<div>
				<p className="emph">Payment Information</p>
				{paymentOptions}
			</div>
		)
	}
}

export default Payment;


// WEBPACK FOOTER //
// ./src/components/Payment.jsx